import { BenefitDTOBenefitEnum, DocumentsDTO, TenantDTO } from 'probonio-shared-ui/api';
import { BenefitNavigationExtensionInterface } from '../../../../extension/interface/benefit-navigation.extension.interface';
import { BenefitMenuItemInterface } from '../../nav/BenefitMenuItem';

export class FlexBenefitNavigationExtension extends BenefitNavigationExtensionInterface {
  getMenuItems({ tenant, documents }: { tenant: TenantDTO; documents?: DocumentsDTO }): BenefitMenuItemInterface[] {
    const benefit = BenefitDTOBenefitEnum.Flex.toLowerCase();
    const hasSettings =
      tenant?.flexBenefits?.includes(BenefitDTOBenefitEnum.Lunch) ||
      tenant?.flexBenefits?.includes(BenefitDTOBenefitEnum.Mobility) ||
      tenant?.flexBenefits?.includes(BenefitDTOBenefitEnum.Internet) ||
      tenant?.flexBenefits?.includes(BenefitDTOBenefitEnum.Kita) ||
      tenant?.flexBenefits?.includes(BenefitDTOBenefitEnum.Recreation) ||
      tenant?.flexBenefits?.includes(BenefitDTOBenefitEnum.Coupons);
    const lunchRoutes = tenant?.flexBenefits?.includes(BenefitDTOBenefitEnum.Lunch)
      ? [
          {
            title: ['common:benefit.LUNCH', 'subPage.receipts'],
            to: '/benefits/flex/lunch/receipts',
          },
        ]
      : [];
    const mobilityRoutes = tenant?.flexBenefits?.includes(BenefitDTOBenefitEnum.Mobility)
      ? [
          {
            title: ['common:benefit.MOBILITY', 'subPage.receipts'],
            to: `/benefits/${benefit}/mobility/receipts`,
          },
        ]
      : [];
    const internetRoutes = tenant?.flexBenefits?.includes(BenefitDTOBenefitEnum.Internet)
      ? [
          {
            title: ['common:benefit.INTERNET', 'INTERNET.receipts'],
            to: `/benefits/${benefit}/internet/receipts`,
          },
        ]
      : [];
    const kitaRoutes = tenant?.flexBenefits?.includes(BenefitDTOBenefitEnum.Kita)
      ? [
          {
            title: ['common:benefit.KITA', 'KITA.intervals'],
            to: `/benefits/${benefit}/kita/intervals`,
          },
        ]
      : [];
    const creditCardRoutes = tenant?.flexBenefits?.includes(BenefitDTOBenefitEnum.CreditCard)
      ? [
          {
            title: ['common:benefit.COUPONS', 'CREDIT_CARD.title'],
            to: `/benefits/${benefit}/creditCards`,
            hasSubpages: true,
          },
        ]
      : [];
    const wellpassRoutes = tenant?.activeBenefits?.includes(BenefitDTOBenefitEnum.Wellpass)
      ? [
          {
            title: ['common:benefit.COUPONS', 'WELLPASS.title'],
            to: `/benefits/${benefit}/wellpass`,
            hasSubpages: true,
          },
        ]
      : [];
    const couponRoutes = tenant?.flexBenefits?.includes(BenefitDTOBenefitEnum.Coupons)
      ? [
          {
            title: ['common:benefit.COUPONS', 'couponsModule:budgetPage.subTitle'],
            to: `/benefits/${benefit}/coupons/transactions`,
          },
          { title: ['common:benefit.COUPONS', 'couponsModule:giftsPage.subTitle'], to: `/benefits/${benefit}/coupons/gifts` },
          {
            title: ['common:benefit.COUPONS', 'couponsModule:incentivesPage.subTitle'],
            to: `/benefits/${benefit}/coupons/incentives`,
          },
        ]
      : [];
    const recreationRoutes = tenant?.flexBenefits?.includes(BenefitDTOBenefitEnum.Recreation)
      ? [
          {
            title: ['common:benefit.RECREATION', 'subPage.receipts'],
            to: `/benefits/${benefit}/recreation/receipts`,
          },
        ]
      : [];

    return [
      { title: 'subPage.employees', to: `/benefits/${benefit}` },
      ...lunchRoutes,
      ...mobilityRoutes,
      ...internetRoutes,
      ...kitaRoutes,
      ...creditCardRoutes,
      ...wellpassRoutes,
      ...couponRoutes,
      ...recreationRoutes,
      ...(hasSettings ? [{ title: 'subPage.settings', to: `/benefits/${benefit}/settings`, hasSubpages: true }] : []),
      { title: 'subPage.payrollReport', to: `/benefits/${benefit}/payrollReport` },
      ...(documents?.totalCount ? [{ title: 'subPage.documents', to: `/benefits/${benefit}/documents` }] : []),
    ];
  }
}
